import {
  Link, styled, Typography, TypographyProps,
} from '@mui/material';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { DialogImage } from '../shared';
import Dialog from '../shared/Dialog';
import { getBold } from './ConfirmationDescription';

type Props = {
  selectedPlan: string
}

const ColoredTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: theme.palette.primary.main,
}));

function ExampleBill({ selectedPlan }: Props) {
  const [sampleBillDialogOpen, setSampleBillDialogOpen] = React.useState(false);
  const [imageImport, setImageImport] = React.useState('');

  const linkClicked = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      setSampleBillDialogOpen(true);
      import(`../../assets/images/bills/${selectedPlan}ExampleBill.png`).then((png) => {
        setImageImport(png.default);
        // setSampleBillDialogOpen(true);
      });
    },
    [selectedPlan],
  );

  return (
    <>
      <ColoredTypography variant="body1" data-testid="billExampleTypo">
        <Link
          underline="hover"
          onClick={linkClicked}
          href="#"
          data-testid="billExampleLink"
        >
          <FormattedMessage
            id="confirm-plan-bill.string"
            values={{
              bold: getBold,
            }}
          />
        </Link>
      </ColoredTypography>
      <Dialog
        open={sampleBillDialogOpen}
        handleClose={() => setSampleBillDialogOpen(false)}
      >
        <DialogImage
          alt="Alliant Energy bill example"
          src={imageImport}
          data-testid="billExampleImg"
          loading="lazy"
          width="100%"
        />
      </Dialog>
    </>

  );
}

export default ExampleBill;
